import axios from "axios";

// Global API URL — points to your Laravel backend
// Set REACT_APP_BACKEND_URL in your .env file (e.g., http://localhost:8000)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://api.wappit.app";
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "wappit_admin_token";

export const api = axios.create({
    baseURL: API,
    headers: {
        "Content-Type": "application/json"
    },
});

api.interceptors.request.use((config) => {
    const tok = localStorage.getItem(TOKEN_KEY);
    if (tok) config.headers.Authorization = `Bearer ${tok}`;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err && err.response && err.response.status === 401 && window.location.pathname.startsWith("/admin")) {
            localStorage.removeItem(TOKEN_KEY);
            if (window.location.pathname !== "/admin/login") {
                window.location.href = "/admin/login";
            }
        }
        return Promise.reject(err);
    }
);

// Public
export const submitLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const verifyLeadOtp = (leadId, code) => api.post(`/leads/${leadId}/verify-otp`, {
    code
}).then((r) => r.data);
export const markLeadUnverified = (leadId) => api.post(`/leads/${leadId}/mark-unverified`).then((r) => r.data).catch(() => null);
export const otpSend = (mobile, purpose = "lead", country_code = "91") =>
    api.post("/otp/send", {
        mobile,
        purpose,
        country_code
    }).then((r) => r.data);
export const otpVerify = (mobile, code, purpose = "lead") =>
    api.post("/otp/verify", {
        mobile,
        code,
        purpose
    }).then((r) => r.data);
export const subscribeNewsletter = (email, source = "footer") => api.post("/newsletter", {
    email,
    source
}).then((r) => r.data);
export const adminListNewsletter = (params) => api.get("/admin/newsletter", {
    params
}).then((r) => r.data);
export const adminDeleteNewsletter = (id) => api.delete(`/admin/newsletter/${id}`).then((r) => r.data);
export const adminBulkDeleteNewsletter = (ids) => api.post("/admin/newsletter/bulk-delete", {
    ids
}).then((r) => r.data);
export const exportNewsletterCsvUrl = () => `${API}/admin/newsletter.csv`;
export const adminDeleteLead = (id) => api.delete(`/admin/leads/${id}`).then((r) => r.data);
export const adminBulkDeleteLeads = (ids) => api.post("/admin/leads/bulk-delete", {
    ids
}).then((r) => r.data);

// Auth — two-step (password → OTP)
export const loginStep1 = (email, password) =>
    api.post("/auth/login", {
        email,
        password
    }).then((r) => r.data);
export const loginVerifyOtp = (otp_token, code) =>
    api.post("/auth/verify-otp", {
        otp_token,
        code
    }).then((r) => {
        localStorage.setItem(TOKEN_KEY, r.data.access_token);
        return r.data.user;
    });
export const loginResendOtp = (otp_token) =>
    api.post("/auth/login/resend-otp", {
        otp_token
    }).then((r) => r.data);

// Forgot password
export const forgotPassword = (email) =>
    api.post("/auth/forgot-password", {
        email
    }).then((r) => r.data);
export const resetPassword = (reset_token, code, new_password) =>
    api.post("/auth/reset-password", {
        reset_token,
        code,
        new_password
    }).then((r) => r.data);

// Admin profile
export const fetchProfile = () => api.get("/admin/profile").then((r) => r.data);
export const updateProfile = (data) => api.put("/admin/profile", data).then((r) => r.data);
export const changePassword = (old_password, new_password) =>
    api.post("/admin/change-password", {
        old_password,
        new_password
    }).then((r) => r.data);

export const fetchMe = () => api.get("/auth/me").then((r) => r.data);
export const logoutLocal = () => localStorage.removeItem(TOKEN_KEY);
export const hasToken = () => !!localStorage.getItem(TOKEN_KEY);

// Admin
export const fetchLeads = (params) => api.get("/admin/leads", {
    params
}).then((r) => r.data);
export const fetchStats = () => api.get("/admin/stats").then((r) => r.data);
export const fetchDashboard = () => api.get("/admin/dashboard").then((r) => r.data);
export const fetchActivity = (limit = 25) => api.get("/admin/activity", {
    params: {
        limit
    }
}).then((r) => r.data);
export const exportLeadsCsvUrl = () => {
    const tok = localStorage.getItem(TOKEN_KEY);
    return {
        url: `${API}/admin/leads.csv`,
        token: tok
    };
};
export const downloadLeadsCsv = async () => {
    const res = await api.get("/admin/leads.csv", {
        responseType: "blob"
    });
    const url = window.URL.createObjectURL(new Blob([res.data], {
        type: "text/csv"
    }));
    const a = document.createElement("a");
    a.href = url;
    a.download = `wappit-leads-${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
};